import { PrepareZeroTaxLines } from "./constants";
import { ApiClient } from "services";
import { useMemo, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import ExemptionModal from "./ExemptionModal";
import useModal from "hooks/useModal";
import { NotificationManager } from "react-notifications";
import { useOrganisationContext } from "hooks";


  
export const useTaxExemptChecker = (t, isZatcaSubscribed, document, reload, CanReport) => {
    const id = document ? document.InvoiceID || document.CreditNoteID || document.PrepaymentID : ''
    const [zeroRateLines, setZeroRateLines] = useState([]);
    const client = ApiClient()
    const { selectedOrganisation } = useOrganisationContext();


    const { Modal: NoTaxModal, setIsOpen: setNoTaxModalOpen, isOpen: NoTaxModalOpen, toggle: noTaxModalToggle, ModalHeader: NoTaxModalHeader, ModalBody: NoTaxModalBody } = useModal();
    
    useEffect(async () => {
        const _zeroRateLines = await PrepareZeroTaxLines(client, document, selectedOrganisation)
        setZeroRateLines(_zeroRateLines)
        checkZeroTaxLines(_zeroRateLines)
    }, [document?.Reference])

    const checkZeroTaxLines = (initialLines) => {
        if(!isZatcaSubscribed || !CanReport) return true
        if ((initialLines || zeroRateLines)?.length > 0) {
            noTaxModalToggle()
            return false
        }
        return true
    }

    async function updateReasons(values) {
        try {
            await client.patch(`xero_actions/${selectedOrganisation.id}/document_exempt_reason?InvoiceID=${id}`, {...values}).get("data");
            NotificationManager.success(t("Updated successfully"))
            noTaxModalToggle();
            reload()
        } catch (error) {
            NotificationManager.error(t("Failed to update"))
        }
    }

    const TaxExemptComponent = useMemo(() => {
        return ({ }) => (
            <>
                {NoTaxModalOpen && (
                    <NoTaxModal size="lg">
                        <NoTaxModalHeader toggle={noTaxModalToggle} onClosed={() => { }}>
                            <Trans>Zero Rate Reasons</Trans>
                        </NoTaxModalHeader>
                        <NoTaxModalBody>
                            <ExemptionModal
                                toggle={noTaxModalToggle}
                                updateReasons={updateReasons}
                                t={t}
                                zeroRateLines={zeroRateLines}
                            >
                            </ExemptionModal>
                        </NoTaxModalBody>
                    </NoTaxModal>
                )}
            </>
        )
    }, [NoTaxModal, zeroRateLines, NoTaxModalOpen])

    return [checkZeroTaxLines, TaxExemptComponent]
}

